import { HOME_PROJECT_LABEL } from '@/lib/appConstants.js';
import { activeThreadId } from '@/redux/selectors/pieveSelectors/activeThreadIdSelector.js';
import { threadContent, threadProjectLabel } from '@/redux/selectors/pieveSelectors/threadCoreSelectors.js';
import { allowProjectFolders } from '@/redux/selectors/pieveSelectors/sidebarProjectSelectors.js';
import { mainThreadHeaderTitle } from '@/redux/selectors/surfaces/threadSurfaceSelectors/mainThreadHeaderTitle.js';

export const mainThreadHeaderWorkspaceLabel = (state) => {
  if (!allowProjectFolders(state)) {
    return '';
  }
  const threadId = activeThreadId(state);
  const projectLabel = threadProjectLabel(state, threadId);
  if (projectLabel) {
    return projectLabel;
  }
  const content = threadContent(state, threadId);
  const headerWorkspace = String(content?.header?.workspace || '').trim();
  return headerWorkspace || (mainThreadHeaderTitle(state) ? HOME_PROJECT_LABEL : '');
};
